export const LOGGING_IN = 'AUTH/LOGGING_IN';
export const LOGGING_OUT = 'AUTH/LOGGING_OUT';

export const SUBMIT_BILLING = 'BILLING/SUBMIT_BILLING';
export const SUCCESS_SUBMIT_BILLING = 'BILLING/SUCCESS_SUBMIT_BILLING';
export const ERROR_SUBMIT_BILLING = 'BILLING/ERROR_SUBMIT_BILLING';

export const ADD_DEBT = 'DEBT/ADD_DEBT';
export const ADDED_DEBT = 'DEBT/ADDED_DEBT';
export const ERROR_ADD_DEBT = 'DEBT/ERROR_ADD_DEBT';
export const EDIT_DEBT = 'DEBT/EDIT_DEBT';
export const EDITED_DEBT = 'DEBT/EDITED_DEBT';
export const ERROR_EDIT_DEBT = 'DEBT/ERROR_EDIT_DEBT';
export const FOUND_DEBTS = 'DEBT/FOUND_DEBTS';
export const ERROR_FOUND_DEBTS = 'DEBT/ERROR_FOUND_DEBTS';
export const FETCH_DEBT = 'DEBT/FETCH_DEBT';
export const FOUND_DEBT = 'DEBT/FOUND_DEBT';
export const ERROR_FOUND_DEBT = 'DEBT/ERROR_FOUND_DEBT';

// TODO: Separate out settlement and schedule pieces to separate section
export const ADD_SETTLEMENT = 'DEBT/ADD_SETTLEMENT';
export const ADDED_SETTLEMENT = 'DEBT/ADDED_SETTLEMENT';
export const ERROR_ADD_SETTLEMENT = 'DEBT/ERROR_ADD_SETTLEMENT';
export const ADD_SCHEDULE = 'DEBT/ADD_SCHEDULE';
export const ADDED_SCHEDULE = 'DEBT/ADDED_SCHEDULE';
export const ERROR_ADD_SCHEDULE = 'DEBT/ERROR_ADD_SCHEDULE';
export const ADD_PAYMENT = 'DEBT/ADD_PAYMENT';
export const ADDED_PAYMENT = 'DEBT/ADDED_PAYMENT';
export const ERROR_ADD_PAYMENT = 'DEBT/ERROR_ADD_PAYMENT';

export const CLEAR_ERRORS = 'ERROR/CLEAR_ERRORS';

export const SET_MOBILE = 'LAYOUT/SET_MOBILE';

export const FETCH_ACCOUNTS = 'MX/FETCH_ACCOUNTS';
export const FOUND_ACCOUNTS = 'MX/FOUND_ACCOUNTS';
export const ERROR_FETCH_ACCOUNTS = 'MX/ERROR_FETCH_ACCOUNTS';
export const HIDE_ACCOUNT = 'MX/HIDE_ACCOUNT';
export const HID_ACCOUNT = 'MX/HID_ACCOUNT';
export const ERROR_HIDE_ACCOUNT = 'MX/ERROR_HIDE_ACCOUNT';
export const SHOW_ACCOUNT = 'MX/SHOW_ACCOUNT';
export const SHOWED_ACCOUNT = 'MX/SHOWED_ACCOUNT';
export const ERROR_SHOW_ACCOUNT = 'MX/ERROR_SHOW_ACCOUNT';
export const CLEAR_ACCOUNTS_CACHE = 'MX/CLEAR_ACCOUNTS_CACHE';
export const CLEARED_ACCOUNTS_CACHE = 'MX/CLEARED_ACCOUNTS_CACHE';
export const ERROR_CLEAR_ACCOUNTS_CACHE = 'MX/ERROR_CLEAR_ACCOUNTS_CACHE';
export const CLEAR_CONNECT_URL = 'MX/CLEAR_CONNECT_URL';
export const FETCH_CONNECT_URL = 'MX/FETCH_CONNECT_URL';
export const FOUND_CONNECT_URL = 'MX/FOUND_CONNECT_URL';
export const ERROR_FETCH_CONNECT_URL = 'MX/ERROR_FETCH_CONNECT_URL';
export const REMOVE_MEMBER = 'MX/REMOVE_MEMBER';
export const REMOVED_MEMBER = 'MX/REMOVED_MEMBER';
export const ERROR_REMOVE_MEMBER = 'MX/ERROR_REMOVE_MEMBER';
export const FETCH_TRANSACTIONS = 'MX/FETCH_TRANSACTIONS';
export const FOUND_TRANSACTIONS = 'MX/FOUND_TRANSACTIONS';
export const ERROR_FETCH_TRANSACTIONS = 'MX/ERROR_FETCH_TRANSACTIONS';
export const ADD_TRANSACTION = 'MX/ADD_TRANSACTION';
export const ADDED_TRANSACTION = 'MX/ADDED_TRANSACTION';
export const ERROR_ADD_TRANSACTION = 'MX/ERROR_ADD_TRANSACTION';
export const DELETE_TRANSACTION = 'MX/DELETE_TRANSACTION';
export const DELETED_TRANSACTION = 'MX/DELETED_TRANSACTION';
export const ERROR_DELETE_TRANSACTION = 'MX/ERROR_DELETE_TRANSACTION';
export const UPDATE_TRANSACTION = 'MX/UPDATE_TRANSACTION';
export const UPDATED_TRANSACTION = 'MX/UPDATED_TRANSACTION';
export const ERROR_UPDATE_TRANSACTION = 'MX/ERROR_UPDATE_TRANSACTION';
export const IGNORE_TRANSACTION = 'MX/IGNORE_TRANSACTION';
export const IGNORED_TRANSACTION = 'MX/IGNORED_TRANSACTION';
export const ERROR_IGNORE_TRANSACTION = 'MX/ERROR_IGNORE_TRANSACTION';
export const INCLUDE_TRANSACTION = 'MX/INCLUDE_TRANSACTION';
export const INCLUDED_TRANSACTION = 'MX/INCLUDED_TRANSACTION';
export const ERROR_INCLUDE_TRANSACTION = 'MX/ERROR_INCLUDE_TRANSACTION';

export const SUBMIT_DETAILS = 'ONBOARD/SUBMIT_DETAILS';
export const SUCCESS_SUBMIT_DETAILS = 'ONBOARD/SUCCESS_SUBMIT_DETAILS';
export const ERROR_SUBMIT_DETAILS = 'ONBOARD/ERROR_SUBMIT_DETAILS';
export const SET_CURRENT_STEP = 'ONBOARD/SET_CURRENT_STEP';
export const SAVE_OR_SUBMIT = 'ONBOARD/SAVE_OR_SUBMIT';
export const SUCCESS_SUBMIT_AGREEMENT = 'ONBOARD/SUCCESS_SUBMIT_AGREEMENT';
export const ERROR_AGREEMENT = 'ONBOARD/ERROR_AGREEMENT';

export const ADD_LOCAL_STORAGE = 'USER/ADD_LOCAL_STORAGE';
export const FETCH_USER_INFO = 'USER/FETCH_USER_INFO';
export const FOUND_USER_INFO = 'USER/FOUND_USER_INFO';
export const ERROR_USER_INFO = 'USER/ERROR_USER_INFO';
export const CONTACT_SUBMIT = 'USER/CONTACT_SUBMIT';
export const SUCCESS_CONTACT_SUBMIT = 'USER/SUCCESS_CONTACT_SUBMIT';
export const ERROR_CONTACT_SUBMIT = 'USER/ERROR_CONTACT_SUBMIT';

export const FOUND_PAYOFF_DEBT = 'PORTAL/FOUND_PAYOFF_DEBT';
export const ERROR_PAYOFF_DEBT = 'PORTAL/ERROR_PAYOFF_DEBT';
export const EDITED_PAYOFF_DEBT = 'PORTAL/EDITED_PAYOFF_DEBT';
export const ERROR_EDIT_PAYOFF_DEBT = 'PORTAL/ERROR_EDIT_PAYOFF_DEBT';
export const EDIT_PAYOFF_DEBT = 'PORTAL/EDIT_PAYOFF_DEBT';

export const UPDATE_DUMMY_DATA_VISIBILITY       = 'USER/UPDATE_DUMMY_DATA_VISIBILITY';
export const UPDATED_DUMMY_DATA_VISIBILITY      = 'USER/UPDATED_DUMMY_DATA_VISIBILITY';
export const ERROR_UPDATE_DUMMY_DATA_VISIBILITY = 'USER/ERROR_UPDATE_DUMMY_DATA_VISIBILITY';

export const UPDATE_DUMMY_PAYOFF_VISIBILITY       = 'USER/UPDATE_DUMMY_PAYOFF_VISIBILITY';
export const UPDATED_DUMMY_PAYOFF_VISIBILITY      = 'USER/UPDATED_DUMMY_PAYOFF_VISIBILITY';
export const ERROR_UPDATE_DUMMY_PAYOFF_VISIBILITY = 'USER/ERROR_UPDATE_DUMMY_PAYOFF_VISIBILITY';
